import React, { useContext, useEffect, useState } from 'react';
import { ThemeContext } from '../../context/ThemeContext';
import { DefaultTokenContext } from '../../context/DefaultTokenContext';

import useSecureStorage from '../../hooks/useSecureStorage';
import useQssMnemonic from '../../hooks/useQssMnemonic';
import useQwalletServer from '../../hooks/useQwalletServer';

import CustomText from '../../styles/CustomText';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { checkQssMnemonicName, checkPincode, RootState } from '../../store';
import { BounceLoader } from "react-spinners";

import { checkQssPassword } from '../../store';
import { getTelegramId } from '../../utils/telegramClientData';
import { tgShowAlert } from '../../utils/telegramPopup';

/**
 * @brief QSS 니모닉 데이터 저장
 * @returns 
 */
const QssSaveProcess: React.FC = () => {
	const { theme } = useContext(ThemeContext)
	const { getNetworkInfo } = useContext(DefaultTokenContext);

	let navigate = useNavigate();
	let dispatch = useDispatch();
	const { t } = useTranslation();
    const { getLogin,
			retrieveEncryptedData, 
			getWalletAddress, 
			setIsUseQss, 
			setIsSavedQssMnemonic, 
			setLocalMnemonicHash,
			getBlockChain,
			getNetworkWalletAddress } = useSecureStorage()
    const { addQssMnemonic,  } = useQssMnemonic()
	
	const { updateAirdropWalletAddress } = useQwalletServer()

    const [mnemonic, setMnemonic] = useState('')
    
    const pincode = useSelector((state: RootState) => state.pincode.value);
    const qssPassword = useSelector((state: RootState) => state.qssPassword.value);
	const qssMnemonicName = useSelector((state: RootState) => state.qssMnemonicName.value);

	useEffect(() => {
		const getMnemonic = async () => {
			try {
                await fetchMnemonic()
			} catch (error) {
				console.error('Error generating wallet:', error)
			}
		}

		getMnemonic()
	}, [])

    const fetchMnemonic = async () => {
		const walletAddress = await getWalletAddress()
        console.log(`QssSaveProcess fetchMnemonic walletAddress : ${walletAddress}`)
		if (walletAddress) {
			try {
				const walletUnlockPin = pincode
				const network = await getBlockChain()
				const data = await retrieveEncryptedData(network, walletUnlockPin)
				if (data && data.mnemonic) {
                    const mnemonic = data.mnemonic
					const publicKey = data.publicKey
					setMnemonic(mnemonic)
					await saveQss(mnemonic, publicKey)
				}

				// redux 임시저장 데이터 삭제
				dispatch(checkPincode('')) // 지갑언락 핀코드 제거
				dispatch(checkQssPassword('')) // QSS 비밀번호 제거
				dispatch(checkQssMnemonicName('')) // QSS 니모닉이름 제거
			} catch (error) {
				console.error('Failed to retrieve mnemonic:', error)
			}
		}
	}

	const saveQss = async (mnemonic: string, walletAddress: string) => {
		try {
			// console.log(`QssSaveProcess pincode : ${pincode}`)
			// console.log(`QssSaveProcess mnemonic : `, mnemonic)
			// console.log(`QssSaveProcess qssPassword : `, qssPassword)
			// console.log(`QssSaveProcess qssMnemonic Name : `, qssMnemonicName)

			// qss 니모닉코드 암호화 저장
			const name = qssMnemonicName;
			// console.log(`saveQss qss 니모닉 저장 이름 : ${name}`)

			let networkName = await getBlockChain()
			if(null == networkName || '' === networkName) {
				tgShowAlert(t('qss_save_process_screen_message_04'))
				return false;
			}
			// console.log(`saveQss qss 니모닉 네트워크 이름 : ${networkName}`)

			// 네트워크 설정 정보
			const defaultNetworks = await getNetworkInfo('')
			console.log(`defaultNetworks : `, defaultNetworks)
			const activeNetworks = defaultNetworks.filter(network => network.is_active);
			console.log(`활성화된 네트워크 목록:`, activeNetworks);

			// 활성화된 네트워크 별로 지갑 생성 및 저장
			let qssResult = false;
			for (const network of activeNetworks) {
				const result = await addQssMnemonic(qssPassword, network.symbol.toLowerCase(), name, mnemonic);
				if(false === result) {
					qssResult = false;
					break;
				}
				qssResult = true;
			}

			// qss 니모닉저장 실패
			if(false === qssResult) {
				alert('QSS mnemonic save error')
				await setIsUseQss('false')
				await setIsSavedQssMnemonic('false')
				setTimeout(() => {
					navigate('/CreateWallet', { replace: true });
				}, 1000)
				return false;
			}

			// 환경설정 qSS 사용상태 저장 
			await setIsUseQss('true')
			await setIsSavedQssMnemonic('true')

			// 니모닉 해시 저장
			await setLocalMnemonicHash(mnemonic)

			// 게임 airdrop 주소 지갑 bsc 주소로 업데이트
			const bscWalletAddress = await getNetworkWalletAddress(process.env.REACT_APP_AIRDROP_ADDRESS_NETWORK_NAME?.toLowerCase() || '')
			const telegramId = await getTelegramId()
			
			if(bscWalletAddress) {
				const updateAirdropAddress = await updateAirdropWalletAddress(bscWalletAddress, telegramId)
				console.log(`updateAirdropAddress : `, updateAirdropAddress)
				if(false === updateAirdropAddress) {
					console.error('Error airdrop address update:')
					alert('Error airdrop address update');
					navigate(`/CreateWallet`, { replace: true, state: { } });
					return false;
				}
			} else {
				console.error('Error airdrop address update: no wallet address')
				alert('Error airdrop address update. no wallet address');
				return false;
			}
			
			const loginStatus = await getLogin()
			if(false === loginStatus) {
				// 지갑 생성 전
				setTimeout(() => {
					navigate('/WalletCreationComplete', { replace: true });
				}, 1000)
			} else {
				// 지갑 생성 후
				setTimeout(() => {
					navigate('/QssSettingMnemonicScreen', { replace: true });
				}, 1000)
			}

		} catch (error) {
			console.error('Error qss save:', error)
		}
	}

	const styles = {
		container: {
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			justifyContent: 'center',
			marginTop: "150px"
		} as React.CSSProperties,
		title: {
			fontSize: 24,
			color: theme.label_strong,
			textAlign: 'center',
			margin: "5px 0 0",
		} as React.CSSProperties,
		subTitle1: {
			fontSize: 18,
			color: theme.label_strong,
			textAlign: 'center',
			margin: "5px 0 0"
		} as React.CSSProperties,
		subTitle2: {
			fontSize: 18,
			color: theme.label_strong,
			textAlign: 'center',
			margin: "5px 0 0"
		} as React.CSSProperties
	}

	return (
		<div className='container' style={{ backgroundColor: theme.background_normal }}>
			<div style={styles.container}>
				<div style={{ marginBottom: "10px" }}>
					<BounceLoader color={"blue"} size={100} />
				</div>

				<CustomText weight="medium" style={{ ...styles.title}}>
					{t('qss_save_process_screen_message_01')}
				</CustomText>

				<CustomText style={{ ...styles.subTitle1}}>
					{t('qss_save_process_screen_message_02')}
				</CustomText>

				<CustomText style={{ ...styles.subTitle2}}>
					{t('qss_save_process_screen_message_03')}
				</CustomText>
			</div>
		</div>
	)
}

export default QssSaveProcess
